import { CmsOffer } from '../../../../../../../../types/cmsProduct';
import { formatAmount } from '../../../../formatAmount';
import { getOfferReward } from '../../../../getOfferReward';
import { ProductDetailsSectionOffersPlTableCell } from '../../ProductDetailsSectionOffersPlTable';

// Sum of each offer's highest matched fixed value. Offers that match without
// a fixed value show "see details"; no matching offer shows the hyphen.
export const getCell = (
  offers: CmsOffer[],
  amount: number,
  tenure: number,
  currency: string,
): ProductDetailsSectionOffersPlTableCell => {
  const rewards = offers
    .map((offer) => getOfferReward(offer, amount, tenure))
    .filter((reward) => reward.kind !== 'none');
  if (rewards.length === 0) return { kind: 'empty' };

  const total = rewards.reduce(
    (sum, reward) => sum + (reward.kind === 'value' ? reward.value : 0),
    0,
  );
  return total > 0
    ? { kind: 'value', value: formatAmount(total, currency) }
    : { kind: 'seeDetails' };
};
